module.exports = __webpack_public_path__ + "static/media/19.0638df8c.png";